var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"col-12 col-md-3 py-4"})
}
var staticRenderFns = []

export { render, staticRenderFns }